
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"margin":"auto","background":"0 0"},style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","style":"margin:auto;background:0 0","width":"200","height":"200","viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid","display":"block"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"50","cy":"50","fill":"none","stroke":"#fff","stroke-width":"10","r":"35","stroke-dasharray":"164.93361431346415 56.97787143782138"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","repeatCount":"indefinite","dur":"1s","values":"0 50 50;360 50 50","keyTimes":"0;1"}})])])
          )
        }
      }
    